import React, { useState } from "react";
import "./NftDevelopment.css";

export default function NftDevelopment() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      id: 1,
      title: "Rapid Deployment",
      color:"#ffc0d9",
      border:"1px solid #FFC0D9",
      description:
        "Launch the NFT marketplace quickly using a proven, ready-made framework that significantly reduces development and setup time.",
    },
    {
      id: 2,
      title: "Brand Customization",
      color:"#b5f1cc",
      border: "1px solid #B5F1CC",
      description:
        "Customize platform design, features, and user experience to match brand identity and specific business requirements.",
    },
    {
      id: 3,
      title: "Lower Development Cost",
      color:"#9fe9f6",
      border: "1px solid #9FE9F6",
      description:
        "Reduce overall development time and expenses compared to building a fully custom NFT marketplace from scratch.",
     },
    {
      id: 4,
      color:"#d0bfff",
      border: "1px solid #D0BFFF",
      title: "Enterprise-Grade Security",
      description: "Built with secure smart contracts, encrypted data handling, and reliable infrastructure to protect users and digital assets.",
   },
    {
      id: 5,
      title: "Scalable Architecture",
      color:"#ffe2a5",
      border: "1px solid #FFE2A5",
      description:
        "Easily scale the marketplace as user activity, NFT listings, and transaction volumes grow over time.",
    },
    {
      id: 6,
      title: "Faster Market Entry",
      color:"#ffd8c0",
      border: "1px solid #FFD8C0",
      description:
        "Go live quickly and capture market opportunities without compromising platform quality, performance, or security.",
   },
  ];

  return (
    <div id="nftdevelopment" className="marketmainclass">
        <h2 className="heading">
         Plug-and-Play NFT Marketplace Solutions
        </h2>
        <p className="subheading">
         Plug-and-play NFT marketplace solutions provide a ready-to-use framework for launching a fully functional NFT platform with minimal development effort. Built for speed, flexibility, and security, these solutions help businesses enter the NFT market quickly while maintaining full control over branding, features, and scalability.
        </p>

        <div className="cards">
          {cards.map((card) => (
            <div className="card" key={card.id} style={{border:card.border}}>
              <h3 style={{color:card.color}}>{card.title}</h3>
              <span>{card.description}</span>
             </div>
          ))}
        </div>

       <div className="carousel-container">
          <div className="carousel-wrapper">
            <div
              className="carousel-track"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {cards.map((card) => (
                <div className="carousel-card" key={card.id} style={{border:card.border}}>
                  <h3 style={{color:card.color}}>{card.title}</h3>
                  <span>{card.description}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="carousel-dots">
          {cards.map((_, index) => (
            <button
              key={index}
              className={`dot ${currentSlide === index ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </div>
  );
}
